module.exports = __webpack_public_path__ + "static/media/20240319084853_IMG_6020-min.e543f484.JPG";